import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TableIdPanelStateService {
  private _nonFinancialExpandedByDocument = new Map<string, boolean>();

  isNonFinancialExpanded(documentFileId: string): boolean {
    return this._nonFinancialExpandedByDocument.get(documentFileId) ?? false;
  }

  setNonFinancialExpanded(documentFileId: string, isExpanded: boolean): void {
    this._nonFinancialExpandedByDocument.set(documentFileId, isExpanded);
  }
}
